<template>
    <el-container v-loading="isShowLoading">
        <el-main>
            <el-row>
                <el-form :model="filterData" :inline="true">
                    <el-form-item>
                        <el-input v-model="filterData.configKey" placeholder="请输入配置文件名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="filterData.configValue" placeholder="请输入配置文件信息"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增配置文件</el-button>
                </el-col>
            </el-row>

            <el-table ref="singleTable" :data="recordData" highlight-current-row style="width: 100%" :height="tableHeight" @row-dblclick="onRowDblclick"
            :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column property="configKey" label="配置文件名称" width="280">
                    <template slot-scope="scope">
                      <div
                        class="dt"
                        @click="columnDeal(scope.row.configKey)"
                      >
                        {{scope.row.configKey}}
                      </div>
                    </template>
                </el-table-column>
                <el-table-column property="configValue" label="配置文件信息" width="340">
                    <template slot-scope="scope">
                      <div
                        class="dt"
                        @click="columnDeal(scope.row.configValue)"
                      >
                        {{scope.row.configValue}}
                      </div>
                    </template>
                </el-table-column>
                <el-table-column property="remark" label="备注" width="220">
                    <template slot-scope="scope">
                      <div
                        class="dt"
                        @click="columnDeal(scope.row.remark)"
                      >
                        {{scope.row.remark}}
                      </div>
                    </template>
                </el-table-column>
                <el-table-column property="isValid" label="有效标志" width="80" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isValid == 'Y'">
                            <i class="el-icon-success"></i>有效
                        </div>
                        <div v-else-if="scope.row.isValid == 'N'">
                            <i class="el-icon-remove"></i>无效
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="onEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="danger" @click="onDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row style="margin: 18px 8px">
                <el-col :span="24">
                    <pagination v-show="pagination.total/pagination.pageSize>1" layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.total" :page.sync="pagination.page" :limit.sync="pagination.pageSize"
                        @pagination="onFilter" />
                </el-col>
            </el-row>

            <div style="height: 60px"></div>
            <el-drawer :visible.sync="layout.edit" :show-close="false" :wrapperClosable="false" :withHeader="false"
                :size="pageWidth + 'px'" direction="rtl" custom-class="demo-drawer" style="top: 67px">
                <div class="demo-drawer-content">
                    <Entity v-if="layout.edit" @back="back" @reload="init" v-bind:entity="entityData" ref="itemPanel"></Entity>
                </div>
            </el-drawer>
        </el-main>
    </el-container>
</template>

<script>
    import Entity from "./Entity.vue"

    let _kits, _table
    export default {
        components: {
            Entity
        },
        data() {
            return {
                isShowLoading: true,
                isShowItem: false,
                pageWidth: 600,
                //页面布局相关
                layout: {
                    loading: true,
                    width: 600,
                    wd: "80%",
                    edit: false
                },
                //数据绑定相关
                filterData: {}, //过滤信息
                recordData: [], //展示信息
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 10
                }, //分页信息
                entityData: {} //具体某一项信息
            }
        },
        methods: {
            onAdd() {
                this.layout.edit = true
                this.entityData = {}
            },
            onRowDblclick(row, column, event) {
                console.log(row)
            },
            onEdit(item) {
                this.entityData = _kits.assign(item)
                this.layout.edit = true
            },
            onDel(item) {
                _kits.confirm({
                    text: "确定删除此配置文件?",
                    yes: () => {
                        this.layout.loading = true
                        _kits.message("正在删除配置文件")
                        _kits.api.update(
                            "DELETESYSCONFIGDETAILS", {
                                configKey: item.configKey
                            },
                            () => {
                                this.init();
                            }
                        )
                    }
                })
            },
            onFilter() {
                console.log(_kits.data("filterData"))
                this.layout.loading = true
                _table.load()
            },
            init() {
                _table.load()
            },
            back() {
                //console.log("back")
                this.layout.edit = false
            }
        },
        created() {
            this.pageWidth = window.innerWidth - 200
            _kits = this.$kits()
            _table = _kits.table(
                "QUERYSYSCONFIGLIST",
                () => {
                    return Object.assign({}, this.filterData, this.pagination)
                },
                result => {
                    this.isShowLoading = false
                    this.recordData = result.list
                    this.pagination.total = Number.parseInt(result.total)
                }
            )
            this.init()
        },
        mounted() {}
    }
</script>
<style scoped>
</style>
